query GetAudienceForEntityList($id: ID!) {
    audience(id: $id) {
        id
        name
        description
        createdTime
        creatorUser {
            id
            name
        }
        isRecentlyCreated
        isWebFX
        members {
            totalCount
        }
    }
}
